import React from "react";
import PropTypes from "prop-types";

export default function Download(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 7.5H12.5V5C12.5 2.24243 10.2576 0 7.5 0C4.74243 0 2.5 2.24243 2.5 5V7.5H1.875C0.841675 7.5 0 8.34076 0 9.375V18.125C0 19.1592 0.841675 20 1.875 20H13.125C14.1583 20 15 19.1592 15 18.125V9.375C15 8.34076 14.1583 7.5 13.125 7.5ZM4.16672 5C4.16672 3.16162 5.66162 1.66672 7.5 1.66672C9.33838 1.66672 10.8333 3.16162 10.8333 5V7.5H4.16672V5Z"
        fill={props.fill}
      />
    </svg>
  );
}

Download.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Download.defaultProps = {
  className: "",
  fill: "#E9F1FE",
  width: 15,
  height: 20
};
